<template>
  <div class="trade-head">
    <van-nav-bar>
        <template #left>
          <van-icon name="bars" size="24px" @click="toType" style="display: none;" />
            &nbsp;
            <span style="font-size: 18px;font-weight: 700;">{{ safeName }}</span>
        </template>
        <template #right >
          <van-icon name="revoke" size="24" @click="toPage" />
          <div @click="changeTable" style="display: none;">
            <span v-if="safeShowType == 1">{{ $t('option.kline') }}</span>
            <span v-else>{{ $t('option.listtitle') }}</span>
            &nbsp;
            <van-icon v-if="safeShowType == 1" name="chart-trending-o" size="24" />
            <van-icon v-else name="records-o" size="24" />
          </div>
        </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: 'OperationHeader',
  props: ['name','showType'],
  computed:{
    safeName(){
        return this.name || null
    },
    safeShowType(){
        return this.showType || 0
    }
  },
  watch: {
    name() {
    },
    showType() {
    }
  },
  methods:{
    toType(){
      this.$emit('child-event')
    },
    changeTable(){
      this.$emit('changeTable')
    },
    toPage(){
      this.$emit('to-page')
    }
  }
}
</script>

<style>

</style>
